import ActionTypeZona from "../ActionTypeZona";

export default class FinalizarComando extends ActionTypeZona {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.flag.procesandoComandoCrear = false;
        nuevoEstado.flag.procesandoComandoUpdate = false;
        nuevoEstado.flag.procesandoComandoEliminar = false;
        nuevoEstado.flag.procesandoComandoBuscar = false;
        return nuevoEstado;
    }
}
